/**
 * Sets up subscribe click event for the survey
 */
import { useEffect } from "react";
import { conditionsEngine, subscribe } from "../../util";
import { SET_RENDER, SURVEY_CONTENT } from "../../constants";

const useSurveySubscribeClickEvent = (props) => {
  useEffect(() => {
    if (!props.definition) return;

    const {
      definition,
      hasClicked,
      hasHovered,
      hasMouseLeftViewport,
      hasTimedOut,
      dispatch,
      handleAutoPopUp,
      handleOnClickCondition,
      handleOnHoverCondition,
    } = props;

    const {
      surveyDisplayConditions: { autoPopUp, ...restSurveyDisplayConditions },
      id,
    } = definition[SURVEY_CONTENT];

    const engineOptions = {
      clickCallback: handleOnClickCondition,
      hoverCallback: handleOnHoverCondition,
    };

    subscribe(`surveyClickEvent.${id}`, () => {
      if (!hasClicked.current) {
        hasClicked.current = true;
      }
      const isRender = conditionsEngine(restSurveyDisplayConditions, {
        ...engineOptions,
        isHoveredTrue: hasHovered.current,
        isClickTrue: hasClicked.current,
        isMouseLeftViewportTrue: hasMouseLeftViewport.current,
        isIdled: hasTimedOut.current,
      });

      dispatch({
        type: SET_RENDER,
        payload: isRender,
      });
      handleAutoPopUp(autoPopUp);
    });
  }, []);
};

export default useSurveySubscribeClickEvent;
